import { Switch } from "@/components/ui/switch";

export interface LabelSettingsProps {
  disabled?: boolean;
  showLabel: boolean;
  onCheckDisplayLabel?: (value: boolean) => void;
}

export const LabelSettings = (props: LabelSettingsProps) => {
  const { disabled, showLabel, onCheckDisplayLabel } = props;

  return (
    <div className="flex justify-between">
      <p className="text-xs mb-1 text-grey">Display Label</p>
      <Switch
        disabled={disabled}
        data-testid="display-name-switch"
        checked={showLabel}
        onCheckedChange={onCheckDisplayLabel}
      />
    </div>
  );
};
